import React, { memo, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { left_arrow, right_arrow } from '../../assets/imgs'
import { useLazyPropertiesViewQuery, useLazyPropertyReceptionListQuery, useLazyPropertyReverificationViewQuery, useLazyReceptionListGetQuery, usePropertiesAddMutation, usePropertiesEditMutation } from '../../screens/redux/api/api'
import { toast } from 'react-toastify'
import SelectBox from '../SelectBox'
import CancelIcon from '@mui/icons-material/Cancel';
import { Spinner } from 'react-bootstrap'

const ReverifyProperty = ({ data }) => {

    const navigate = useNavigate()
    const location = useLocation()
    const [valueType, setValueType] = useState('')
    const [loader, setLoader] = useState(false)
    const [edit, setEdit] = useState(false)

    const [userName, setUserName] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [userID, setUserID] = useState([]);
    const [validation, setValidation] = useState("");
    const [receptionList, setReceptionList] = useState([])
    const [receptions, setReceptions] = useState([])


    const [propertyData, setPropertyData] = useState({
        name: '',
        owner_name: '',
        receptionists: [],
        owner_id: '',
        receptionist_ids: []
    })

    //RTK
    const [propertyView] = useLazyPropertyReverificationViewQuery()
    const [propertyEdit] = usePropertiesAddMutation()
    //RTK
    const [receptionListApi] = useLazyPropertyReceptionListQuery()

    const removeReceptionist = (index) => {
        const updatedUserNames = [...userName];
        updatedUserNames.splice(index, 1);
        setUserName(updatedUserNames);

        const updatedSelectedUsers = [...selectedUsers];
        updatedSelectedUsers.splice(index, 1);
        setSelectedUsers(updatedSelectedUsers);
    };

    const getDetails = (id) => {
        setLoader(true)
        propertyView(id)
            .unwrap()
            .then((res) => {
                setLoader(false)
                const property = res?.data || {};
                const receptionists = Array.isArray(property.receptionists)
                    ? property.receptionists
                    : [];

                setPropertyData({
                    name: property.name || '',
                    owner_name: property.owner?.name || '',
                    receptionists: receptionists,
                    owner_id: property.owner_id || '',
                    receptionist_ids: receptionists.map(r => r.id) || []
                });
                setValueType(property.property_type || '');

                // Set both the names and the full objects
                setUserName(receptionists.map(item => item?.name));
                setSelectedUsers(receptionists);
            })
            .catch((err) => {
                console.log(err);
                toast.error('Failed to fetch property details');
            });
    };
    const handleEdit = (id) => {
        if (!edit) {
            setEdit(true);
            return;
        }

        setLoader(true);
        const formData = new FormData();
        formData.append("name", propertyData.name);
        formData.append("property_type", valueType);
        formData.append("owner_id", propertyData.owner_id);
        formData.append("owner_name", propertyData.owner_name);
        formData.append('property_id', id);

        // Only append selected receptionist IDs
        selectedUsers.forEach((item, index) => {
            formData.append(`receptionist_id[${index}]`, item.id);
        });

        // console.log('payload', formData);

        propertyEdit(formData)
            .unwrap()
            .then((res) => {
                if (res?.status === 'success') {
                    toast.success(res?.message);
                    setEdit(false);
                    getDetails(id);
                }
            })
            .catch((err) => {
                console.log(err);
                toast.error(err?.data?.message || 'Failed to update property');
            })
            .finally(() => {
                setLoader(false);
            });
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target
        setPropertyData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const handleReceptionistChange = (index, value) => {
        const updatedReceptionists = [...propertyData.receptionists]
        updatedReceptionists[index] = {
            ...updatedReceptionists[index],
            name: value
        }
        setPropertyData(prev => ({
            ...prev,
            receptionists: updatedReceptionists,
            receptionist_ids: updatedReceptionists.map(r => r.id)
        }))
    }

    const getList = () => {
        receptionListApi()
            .unwrap()
            .then((res) => {
                console.log(res)
                setReceptionList(res?.data)
            }).catch((err) => {
                console.log(err)
            })
    }

    useEffect(() => {
        if (data?.data?.id) {
            getDetails(data.data.id)
        }
        // getList()
    }, [data?.data?.id])

    // console.log(selectedUsers, 'username', userName)



    return (
        <div className="mt-2">
            <div className='d-flex ac-jb'>
                <div className='d-flex ac-js pointer gap-2' onClick={() => navigate(-1)}>
                    <img src={left_arrow} className='leftArrow mb-3' alt="back" />
                    <p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary">Back</p>
                </div>
                {/* <div onClick={() => setEdit(!edit)}>
                    {!edit ? (<p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary cust-btn recep-yes"
                        style={{ cursor: 'pointer' }}
                    >
                        Edit
                    </p>) : (<p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary cust-btn recep-yes"
                        style={{ cursor: 'pointer' }}
                        onClick={() => getDetails(data?.data?.id)}
                    >
                        cancel
                    </p>)}
                </div> */}
            </div>

            <div className="">
                <div className='d-flex gap-5 mb-4'>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Property Name
                        </h4>
                        <input
                            type="text"
                            className="input-pop ps-2 w-100"
                            placeholder="Property Name"
                            name="name"
                            value={propertyData.name}
                            onChange={handleInputChange}
                            disabled={!edit}
                        />
                    </div>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Owner Name
                        </h4>
                        <input
                            type="text"
                            className="input-pop ps-2 w-100"
                            placeholder="Owner"
                            name="owner_name"
                            value={propertyData.owner_name}
                            onChange={handleInputChange}
                            disabled
                        />
                    </div>
                </div>

                <div className='d-flex gap-5 mb-4'>
                    <div className='col-md-5'>
                        {userName.length != 0 && (
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Receptionist
                            </h4>
                        )}
                        {edit && (<div className='mb-4'>
                            <SelectBox
                                array_list={receptionList}
                                value_text={userName}
                                setvalue_text={(values) => {
                                    let arr = [];
                                    receptionList?.forEach(item => {
                                        if (values.includes(item?.name)) {
                                            arr.push(item);
                                        }
                                    });
                                    setSelectedUsers(arr);
                                    setUserName(values);
                                }} // array
                                setvalue_id={setUserID} // array
                                value_id={userID} // array
                                placeholder_text={"Select..."} // string
                                setValidation={setValidation} // string
                                isMulti={true} // boolean
                                isTextArea={false} // boolean
                            />
                        </div>)}


                        <div className='d-flex ac-jb gap-2'>
                            {/* Existing receptionists (if any) */}
                            {!edit && propertyData.receptionists.map((item, index) => (
                                <input
                                    key={`existing-${item.id || index}`}
                                    className="input-pop ps-2 w-100"
                                    placeholder="Receptionist"
                                    value={item.name || ''}
                                    onChange={(e) => handleReceptionistChange(index, e.target.value)}
                                    disabled={!edit}
                                />
                            ))}

                            {/* New selections from userName */}
                            {edit && userName.map((name, index) => (
                                <div key={`new-${index}`} className="position-relative">
                                    <input
                                        value={name}
                                        className="input-pop ps-2 w-100"
                                        placeholder="Receptionist"
                                        readOnly
                                    />
                                    <CancelIcon
                                        className="position-absolute cancel-icon"
                                        style={{ right: '5px', top: '5px', cursor: 'pointer' }}
                                        onClick={() => removeReceptionist(index)}

                                    />
                                </div>
                            ))}
                        </div>

                    </div>
                    <div className="col-md-5">
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Type
                        </h4>
                        <div className="d-flex ac-jb">
                            {valueType == 2 && (<p className={`${valueType == 2 ? "yellow-box" : "yellow-box_new"}`}>
                                Individual Villa
                            </p>)}
                            {valueType == 1 && (<p className={`${valueType == 1 ? "yellow-box" : "yellow-box_new"}`}>
                                Hotel Rooms
                            </p>)}
                        </div>
                    </div>
                </div>
                {/* <div className='d-flex ac-je'>
                    <div className='d-flex ac-js pointer gap-2' onClick={() => handleEdit(data?.data?.id)}>
                        <p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary">
                            {edit ? (loader ? 'Saving...' : 'Save') : ''}
                        </p>
                        {edit && <img src={right_arrow} className='leftArrow mb-3' alt="save" />}
                    </div>
                </div> */}
            </div>
            {loader && (
                <div style={{ zIndex: 2000, position: "fixed", top: "45%", left: "49%", }}  >
                    <Spinner animation="border" className="primary1" />
                </div>)}
        </div>
    )
}

export default memo(ReverifyProperty)